import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { Select, Form, Button, Input, Upload, message, Icon,Typography, Card, Breadcrumb, Divider, Table, DatePicker, Row, Col } from 'antd';
import moment from 'moment';
import echarts from 'echarts';
import FilterForm from '@/components/form/filterForm';
import { getStaticPersonWeekAtt, getSttaticPersonMonthList, getStaticPersonMonthData } from '@/api/api';
import utils from '@/api/util';
import './statistical.css';
import servers from '@/api/server';

const FormItem = Form.Item;
const Option = Select.Option;
const { Text, Title } = Typography;
const { MonthPicker, RangePicker, WeekPicker } = DatePicker;
let week_cavans;

const filterItems = [
    {
        name: '姓名',
        key: 'nickName',
        placeholder: '姓名',
        width: '140px'
    }, {
        name: '月度时间',
        key: 'countMoth',
        type: 'monthPicker',
        placeholder: '月度时间'
    }
]


class Statistic_person extends Component {
    constructor(props) {
        super(props);
        console.log(props)
        this.state = {
            dataSource: [],
            table_loading: false,
            monthRows: 10,
            countMoth: '',
            pagination: {
                pageSize: 10,
                hideOnSinglePage: true,
            },
            realWorkList: [],
            missNumList: [],
            leaveNumList: [],
            lateNumList: [],
            echarts_flag: true,
        }
        this.weekAttendanceEcharts = this.weekAttendanceEcharts.bind(this);
        this.dataFilter = this.dataFilter.bind(this);
        this.getWeekAttendance = this.getWeekAttendance.bind(this);
        this.getMonthList = this.getMonthList.bind(this);
        this.getMonthData = this.getMonthData.bind(this);
        this.monthTableChange = this.monthTableChange.bind(this)
    }

    componentDidMount() {
        week_cavans = echarts.init(document.getElementById('weekAttendance'));
        week_cavans.showLoading();
        let nowTime = (new Date()).getTime();
        let nowDate = utils.formatTimestamp(nowTime, 'date');
        let nowMonth = utils.formatTimestamp(nowTime, 'yearMonth');
        let weekRange = utils.getWeekRange(nowDate);
        this.getWeekAttendance(weekRange);
        this.getMonthList();
        this.getMonthData({
            page: 1,
            rows: this.state.monthRows,
            countMoth: nowMonth.replace('-', '')
        });
        this.setState({
            curMonth: nowMonth
        })
    }

    // 周出勤率，周切换
    weekChange(date, dateString) {
        let weekRange = utils.getWeekRange(date.format("YYYY-MM-DD"));
        this.getWeekAttendance(weekRange)
    }

    //  获取周出勤率数据
    getWeekAttendance(dataRange) {
        const that = this;
        console.log(dataRange)
        let params = {
            page: 1,
            rows: 7,
            countDateString: dataRange[0],
            countEndDateString: dataRange[1]
        };
        week_cavans.showLoading()
        getStaticPersonWeekAtt(params, res => {
            console.log(res);
            if (res.statusCode !== 1000) {
                return
            };
            that.setState({
                echarts_flag: res.rows.length > 0
            })
            that.weekAttendanceEcharts(res.rows)
        }, err => {
            console.log(err)
        })
    }

    // 本月考勤榜单
    getMonthList() {
        const that = this;
        let params = {
            page: 1,
            rows: 5
        }
        getSttaticPersonMonthList(params, res => {
            console.log(res);
            if (res.statusCode !== 1000) {
                return
            };
            that.setState({
                lateNumList: res.lateNumList,
                leaveNumList: res.leaveNumList,
                missNumList: res.missNumList,
                realWorkList: res.realWorkList
            })
        }, err => {
            console.log(err)
        })
    }

    //月考勤列表
    getMonthData(params = {}) {
        const that = this;
        that.setState({
            table_loading: true
        });
        getStaticPersonMonthData(params, res => {
            console.log(res);
            that.setState({
                table_loading: false
            });
            if (res.statusCode !== 1000) {
                return
            };
            const pager = { ...that.state.pagination };
            pager.total = res.total;
            // pager.total = 12;
            that.setState({
                dataSource: res.rows,
                pagination: pager
            })
        }, err => {
            console.log(err);
            that.setState({
                table_loading: false
            });
        })
    }

    weekAttendanceEcharts(values) {
        const that = this;
        week_cavans.clear();
        let categoryData = [];
        let value = [];
        values.map((x, index) => {
            let monthDate = x.countDateString.split('-');
            value.push(parseInt(x.attString))
            categoryData.push(monthDate[1] + '-' + monthDate[2])
        });
        console.log(categoryData)
        week_cavans.setOption({
            tooltip: {
                trigger: 'axis'
            },
            grid: {
                left: '3%',
                right: '15%',
                containLabel: true
            },
            xAxis: {
                type: 'category',
                boundaryGap: false,
                data: categoryData
            },
            tooltip: {
                formatter: (params) => {
                    console.log(params)
                    let str = '';
                    str += params.name + '<br/>';
                    str += params.marker + params.seriesName + ':' + params.value + '%';
                    return str;
                }
            },
            yAxis: {
                type: 'value',
                axisLabel: {
                    formatter: '{value}%'
                }
            },
            series: [
                {
                    name: '出勤率',
                    type: 'line',
                    data: value,
                    label: {
                        show: true,
                        formatter: '{c}%',

                    },
                    // markPoint: {
                    //     data: [
                    //         {type: 'max', name: '最大值'},
                    //         {type: 'min', name: '最小值'}
                    //     ]
                    // },
                    markLine: {
                        data: [
                            {
                                type: 'average',
                                name: '平均值',
                                label: {
                                    formatter: '平均出勤率:{c}%'
                                }
                            }
                        ]
                    }
                }
            ]
        });
        week_cavans.hideLoading()
    }

    // 删选表格
    dataFilter(values) {
        console.log(values);
        const that = this;
        let params = {
            page: 1,
            rows: that.state.monthRows,
            countMoth: values.countMoth ? values.countMoth.format('YYYY-MM').replace('-', '') : that.state.curMonth.replace('-', ''),
            nickName: values.nickName ? values.nickName : ''
        };
        if (values.countMoth) {
            that.setState({
                curMonth: values.countMoth.format('YYYY-MM'),
            })
        };
        const pager = { ...this.state.pagination };
        pager.current = 1;
        that.setState({
            pagination: pager,
        });
        this.getMonthData(params)
    }

    monthTableChange(pagination, filters, sorter) {
        const that = this;
        const pager = { ...this.state.pagination };
        pager.current = pagination.current;
        console.log(sorter)
        this.setState({
            pagination: pager,
        });
        let params = {
            page: pagination.current,
            rows: that.state.monthRows,
            countMoth: that.state.curMonth.replace('-', ''),
            sort: sorter.field,
            order: sorter.order === 'descend' ? 'desc' : 'asc',
        };
        this.getMonthData(params)
    }

    render() {
        const { realWorkList, missNumList, leaveNumList, lateNumList, echarts_flag } = this.state;
        const column = [
            {
                title: '编号',
                dataIndex: 'id',
                align: 'center',
                width: '10%'
            }, {
                title: '姓名',
                dataIndex: 'nickName',
                align: 'center',
                width: '20%'
            }, {
                title: '实出勤/应出勤(天数)',
                dataIndex: 'realWork',
                sorter: true,
                align: 'center',
                width: '20%',
                render: (text, record) => {
                    return (
                        <span>{record.realWork}/{record.mustWork}</span>
                    )
                }
            }, {
                title: '迟到次数',
                dataIndex: 'lateNum',
                align: 'center',
                sorter: true,
                width: '16%'
            }, {
                title: '早退次数',
                dataIndex: 'leaveNum',
                align: 'center',
                sorter: true,
                width: '16%'
            }, {
                title: '缺卡次数',
                dataIndex: 'missNum',
                sorter: true,
                align: 'center',
                width: '16%'
            }
        ];
        return (
            <div className="statistic">
                <Card title={<Text strong style={{fontSize:'15px'}}><i className="iconfont icon-chuqinfenxi c_8bff mr5 vm f18"></i>周出勤率</Text>} className="statistic_panel">
                    <div className="tc">
                        <span className="mr5">选择周：</span>
                        <WeekPicker defaultValue={moment()} onChange={(date, dateString) => this.weekChange(date, dateString)} placeholder="选择周" />
                    </div>
                    {!echarts_flag &&
                        <img src={servers.defaultNoContentPath} alt="暂无内容" className="noContent" />
                    }
                    <div className="statistic_pro_tabPane" id="weekAttendance"></div>
                </Card >

            </div>
        )
    }
}


export default Statistic_person;

